// extracted by mini-css-extract-plugin
export default {"container":"Blog1_container__cRgTg","header":"Blog1_header__tGG6Z","header__tag":"Blog1_header__tag__DBV3B","grid":"Blog1_grid__+hQIZ","h2":"Blog1_h2__YR-vZ"};